import React from 'react';
import NavItems from './app-nav-items.js';

export default function() {
    return (
        <div style={{width: "200px", maxWidth: "200px", minWidth: "200px", backgroundColor: "#222222", height: "100%", overflow: "auto"}}>
            <NavItems />
        </div>
    );
}